import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CustomersTableEntry } from '@dto/customersTableEntry';
import { Customer } from '@models/customer';
import { Operator } from '@models/operator';
import { Observable } from 'rxjs';
import { EntityService } from './entity.service';

@Injectable({
  providedIn: 'root'
})
export class OperatorsService extends EntityService {

  public entityRoute = "operators";

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(http, baseUrl);
  }

  getCustomersOfOperator(operatorId: number): Observable<Customer[]> {
    return this.http.get<Customer[]>(this.baseUrl + 'api/operators/' + operatorId + '/customers');
  }

  getCustomersTableOfOperator(operatorId: number): Observable<CustomersTableEntry[]> {
    return this.http.get<CustomersTableEntry[]>(this.baseUrl + 'api/operators/' + operatorId + '/customersTable');
  }

  matches(operator: Operator, term: string) {
    return operator.id.toString().includes(term.toLowerCase())
      || operator.name.toLowerCase().includes(term.toLowerCase())
  }
}
